module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"select":"Switch language to {name}"},"de":{"select":"Sprache zu {name} wechseln"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/yaml-loader!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/LanguageSwitcher.vue
// module id = tMqF
// module chunks = 0